import styled from "styled-components";

const IconDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    background-color: var(--color-primary-light);
    border-radius: 10px;
    width: 2em;
    height: 2em;
    margin-right: 10px;
`;

export default IconDiv;
